import type { Locale } from '../constants';
import { getLocale } from './locale';

const usZipCodePattern = /^\d{5}(-\d{4})?$/;
const caPostalCodePattern = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
const combinedPostalCodePattern = /^(\d{5}(-\d{4})?|[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d)$/;

const validationObject: Record<Locale, RegExp> = {
    'en-US': usZipCodePattern,
    'en-CA': caPostalCodePattern,
};

export const zipValidation = (zipCode: string) => {
    return validationObject[getLocale()].test(zipCode);
};

export const zipValidationUSandCA = (zipCode: string) => {
    return combinedPostalCodePattern.test(zipCode);
};

export const usPostalCode = (zipCode: string) => usZipCodePattern.test(zipCode);
export const caPostalCode = (postalCode: string) => caPostalCodePattern.test(postalCode);
